import React, { useState, useRef, useEffect } from "react";
import { FaPlay, FaPause, FaVolumeUp } from "react-icons/fa";
import "./RadioPlayer.css"; // Archivo CSS separado

function RadioPlayer() {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(1);
  const [songTitle, setSongTitle] = useState("Cargando...");
  const [songImage, setSongImage] = useState("https://scontent.fpss2-1.fna.fbcdn.net/v/t39.30808-6/473813347_929186079317447_4008315782053814401_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=cc71e4&_nc_eui2=AeEriN48VlKINAP-cwWyTYE_Eyfs9NUx6ZsTJ-z01THpm7khGnz-3Kva3zbrxTpeYB8zBQwWTg9WTfXcQs21DcMt&_nc_ohc=mxtp9ffc4LQQ7kNvgFKLC8N&_nc_oc=AdhuMEWuchhY5Qh7FcAsjWGHg0fBPOqjofTor6wnV4JlpIsJ3wxZCqvRZDEIBsZfnE8&_nc_zt=23&_nc_ht=scontent.fpss2-1.fna&_nc_gid=AQrzEHiSsgne4rktUlJsRpr&oh=00_AYATVBc3J9zDmscKM2mnFakojxfnDSSBesvNj6E4gH4q5g&oe=67B9F3B5");
  const [listeners, setListeners] = useState(0); // Para los oyentes en línea
  
  const streamUrl = "https://streaming01.shockmedia.com.ar/8616/;stream"; // URL del streaming de la radio
  const metadataUrl = "https://streaming01.shockmedia.com.ar/cp/get_info.php?p=8616"; // API donde obtienes los datos de la canción

  <audio ref={audioRef}><source src={streamUrl} type="audio/mpeg" /></audio>

  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        const response = await fetch(metadataUrl);
        const data = await response.json();
        
        // Usar los datos de la API
        setSongTitle(data.title || "RADIO ROCK AND MORE...");
        setSongImage(data.art ? `${data.art}?${new Date().getTime()}` : "https://scontent.fpss2-1.fna.fbcdn.net/v/t39.30808-6/473813347_929186079317447_4008315782053814401_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=cc71e4&_nc_eui2=AeEriN48VlKINAP-cwWyTYE_Eyfs9NUx6ZsTJ-z01THpm7khGnz-3Kva3zbrxTpeYB8zBQwWTg9WTfXcQs21DcMt&_nc_ohc=mxtp9ffc4LQQ7kNvgFKLC8N&_nc_oc=AdhuMEWuchhY5Qh7FcAsjWGHg0fBPOqjofTor6wnV4JlpIsJ3wxZCqvRZDEIBsZfnE8&_nc_zt=23&_nc_ht=scontent.fpss2-1.fna&_nc_gid=AQrzEHiSsgne4rktUlJsRpr&oh=00_AYATVBc3J9zDmscKM2mnFakojxfnDSSBesvNj6E4gH4q5g&oe=67B9F3B5");
        setListeners(data.listeners || 0); // Número de oyentes online
      } catch (error) {
        console.error("Error obteniendo los metadatos", error);
      }
    };

    fetchMetadata();
    const interval = setInterval(fetchMetadata, 10000); // Actualiza cada 10s

    return () => clearInterval(interval);
  }, []); // Dependencias vacías, solo se ejecuta una vez cuando el componente se monta

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play()
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="radio-player-container">
      <div className="radio-info">
        <img src={songImage} alt="Carátula" className="song-image" />
        <h3>{songTitle}</h3>
        <p className="radio-listeners">{listeners} oyentes en línea</p>
      </div>
      <div className="radio-controls">
        <button onClick={togglePlay} className="play-button">
          {isPlaying ? <FaPause /> : <FaPlay />}
        </button>
        <FaVolumeUp className="volume-icon" />
        <input
          type="range"
          min="0"
          max="1"
          step="0.1"
          value={volume}
          onChange={(e) => {
            setVolume(e.target.value);
            audioRef.current.volume = e.target.value;
          }}
          className="volume-slider"
        />
      </div>
      <audio ref={audioRef} src={streamUrl}></audio>
    </div>
  );
}

export default RadioPlayer;
